const baseClass = 'primary-input';
const focusClass = `${baseClass}--focused`;
const notEmptyClass = `${baseClass}--not-empty`;
const checkedClass = `${baseClass}--checked`;

const inputs = [].slice.call(document.querySelectorAll(`.${baseClass}`), 0);

for (let input of inputs) {
	const inputElement = input.querySelector('input, textarea');

	if (!inputElement) {
		continue;
	}

	checkIfEmpty(input, inputElement);

	inputElement.addEventListener('focus', e => {
		checkIfEmpty(input, inputElement);
		input.classList.add(focusClass);
	});

	inputElement.addEventListener('blur', e => {
		checkIfEmpty(input, inputElement);
		input.classList.remove(focusClass);
	});

	inputElement.addEventListener('input', e => {
		checkIfEmpty(input, inputElement);
	});

	if (inputElement.type == 'checkbox' || inputElement.type == 'radio') {
		inputElement.addEventListener('change', e => {
			// TODO: handle checkboxes and radio buttons
		});
	}
}

function checkIfEmpty(input, inputElement) {
	if (inputElement.value != '') {
		input.classList.add(notEmptyClass);
	}
	else {
		input.classList.remove(notEmptyClass);
	}
}